import React, { createContext } from 'react';

import { IFormValues } from '../../../types/shared';

export const FormContext = createContext<IFormValues | undefined>({});
